import { INDUSTRIES } from './homeContent'
import { IMAGES } from './images'

const SECTOR_IMAGES = {
  INDUSTRIAL: IMAGES.industrial,
  COMMERCIAL: IMAGES.consumer,
  AGRICULTURAL: IMAGES.agricultural,
}

const SECTOR_DETAILS = {
  INDUSTRIAL:
    'From manufacturing plants to critical infrastructure, we protect the facilities that keep operations running with programs built for compliance, documentation, and operational continuity.',
  COMMERCIAL:
    'Safe, effective pest solutions for businesses where reputation, compliance, and customer trust matter — from retail and office environments to multi-site commercial operations.',
  AGRICULTURAL:
    'Supporting the agriculture industry with science-based pest management from field to storage, including grain handling, food processing, cold storage, and export facilities.',
}

export const INDUSTRIES_CONTENT = {
  title: 'Industries',
  intro: 'Specialty pest management for the industrial, commercial, and agricultural sectors throughout Texas.',
  heroImage: IMAGES.industries,
  sectors: INDUSTRIES.map((item) => ({
    ...item,
    image: SECTOR_IMAGES[item.title],
    details: SECTOR_DETAILS[item.title],
  })),
  facilityTypes: [
    'Agricultural Operations',
    'Grain Handling & Storage Facilities',
    'Food Processing Plants',
    'Warehouses & Distribution Centers',
    'Cold Storage Facilities',
    'Manufacturing Facilities',
    'Commercial Properties',
    'Transportation & Logistics Operations',
    'Ports of Entry & Marine Facilities',
    'Foreign Trade Zones',
  ],
  gallery: [
    { image: IMAGES.grainHandling, label: 'Grain Handling' },
    { image: IMAGES.foodProcessing, label: 'Food Processing' },
    { image: IMAGES.warehousing, label: 'Warehousing' },
    { image: IMAGES.foodStorage, label: 'Food Storage' },
    { image: IMAGES.portServices, label: 'Port Services' },
    { image: IMAGES.consumer, label: 'Consumer' },
  ],
}
